import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

export const ViewTable = ({captionText,captionText2, headers, rows, subtitle }) => {
    return (
        <TableContainer component={Paper}>
            <Table  aria-label="customized table">
            {(captionText) && <caption>{captionText}</caption>}
                <TableHead >
                    <TableRow>
                        {headers.map((header, index) => (
                           
                            <TableCell key={index}>{header}</TableCell>
                        ))}
                                        
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map((row, rowIndex) => (
                        <TableRow key={rowIndex}>
                            {row.map((cell, cellIndex) => (
                                <TableCell key={cellIndex}>{cell}</TableCell>
                            ))}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default ViewTable;